import React from "react";
import trans from "../../../../utils";
import POIsWorkingShift from "./POIsWorkingShift";

export default function POIsWorkingInfo({ addPOI }) {
	return (
		<>
			<p className="fs-16 fw-500 brand-700 text-capitalize mt-2 ">
				{trans("working info")}
			</p>
			<POIsWorkingShift
				day="sunday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="monday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="tuesday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="wednesday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="thursday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="friday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
			<POIsWorkingShift
				day="saturday"
				workingHours={addPOI.values.workingHours}
				setFieldValue={addPOI.setFieldValue}
			/>
		</>
	);
}
